import { useLazyQuery } from "@apollo/client";
import { useCallback, useEffect, useState } from "react";
import { GET_PATIENTS_QUERY } from "../../queries/patientQueries";

export function useFetchPatients() {
  const [refreshKey, setRefreshKey] = useState(0);

  // Track the current full patient list
  const [currentFullPatientList, setCurrentFullPatientList] = useState([]);

  const [
    getPatients,
    { loading: loadingPatients, data: patientsData, error: patientsError },
  ] = useLazyQuery(GET_PATIENTS_QUERY);

  // Fetch all patients only once on mount
  useEffect(() => {
    getPatients({
      fetchPolicy: "network-only",
    });
  }, [getPatients, refreshKey]);

  useEffect(() => {
    if (patientsData && patientsData.patients) {
      const newPatientList = patientsData.patients;
      setCurrentFullPatientList(newPatientList);
    } else if (patientsError) {
    }
  }, [patientsData, patientsError]);

  const refreshPatients = useCallback(() => {
    setRefreshKey(prevKey => prevKey + 1);
  }, []);

  return {
    refreshPatients,
    loadingPatients,
    patientsData,
    currentFullPatientList,
  };
}
